/*
  src/redux/passwordReset/actions.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import {
  RESET_LINK_REQUESTED,
  RESET_LINK_SENT,
  RESET_LINK_FAILED_TO_SEND,
  PASSWORD_RESET_REQUESTED,
  PASSWORD_RESET,
  PASSWORD_FAILED_TO_RESET
} from './constants';

import {
  AuthenticationError,
  RequestError,
  ServerError,
  NotFoundError,
  ForbiddenError
} from '../errors/types';

import { API_URL } from '../../../config';

export function requestResetLinkForEmail(email){
  return function(dispatch){
    dispatch({
      type:RESET_LINK_REQUESTED
    });

    return fetch(`${API_URL}/pub/v1/user/requestPasswordReset`,{
      method:'POST',
      headers:{
        'Content-Type':'application/json; charset=UTF-8',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        email:email
      })
    })
      .then((res) => {
        if(res.status === 404) throw new NotFoundError();
        if(res.status === 400) throw new RequestError();
        if(res.status === 401) throw new AuthenticationError();
        if(res.status === 403) throw new ForbiddenError();
        if(!res.ok) throw new ServerError();

        return res.json();
      })
      .then((res) => {
        dispatch({
          type:RESET_LINK_SENT
        });
      })
      .catch((err) => {
        dispatch({
          type:RESET_LINK_FAILED_TO_SEND,
          error:true,
          payload:err
        });

        throw err;
      });
  }
}

export function resetPasswordForUser(userId,newPassword,resetToken){
  return function(dispatch){
    dispatch({
      type:PASSWORD_RESET_REQUESTED
    });

    return fetch(`${API_URL}/pub/v1/user/${userId}/resetPassword?token=${resetToken}`,{
      method:'POST',
      headers:{
        'Content-Type':'application/json; charset=UTF-8',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        password:newPassword
      })
    })
      .then((res) => res.json())
      .then((res) => {
        dispatch({
          type:PASSWORD_RESET
        });
      })
      .catch((err) => {
        dispatch({
          type:PASSWORD_FAILED_TO_RESET,
          error:true,
          payload:err
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/passwordReset/actions.js